"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Banner component
 * @author [Jose Antonio Ciccio](https://github.com/jciccio)
 */
var Banner = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Banner, _Component);

  var _super = _createSuper(Banner);

  function Banner(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Banner);
    _this = _super.call(this, props);
    _this.state = {
      visibleTime: 0,
      show: undefined
    };
    return _this;
  }

  (0, _createClass2["default"])(Banner, [{
    key: "render",
    value: function render() {
      // let appearTime = this.props.transitionAppearTime ? this.props.transitionAppearTime : 1000;
      // let transitionTime = this.props.transitionTime ? this.props.transitionTime : 1000;
      return this.renderBanner();
    }
  }, {
    key: "renderImage",
    value: function renderImage() {
      if (this.props.image && this.props.imageClass) {
        return /*#__PURE__*/_react["default"].createElement("img", {
          src: this.props.image,
          className: this.props.imageClass
        });
      }

      if (this.props.image) {
        return /*#__PURE__*/_react["default"].createElement("img", {
          src: this.props.image
        });
      }

      return null;
    }
  }, {
    key: "hideBanner",
    value: function () {
      var _hideBanner = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.visibleTime !== undefined && this.props.visibleTime > 0)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.timeout(1000 + this.props.visibleTime);

              case 3:
                this.close();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function hideBanner() {
        return _hideBanner.apply(this, arguments);
      }

      return hideBanner;
    }()
  }, {
    key: "close",
    value: function close() {
      if (this.props.setShowBanner !== undefined) {
        this.props.setShowBanner(false);
      }

      this.setState({
        show: false
      });
    }
  }, {
    key: "renderBanner",
    value: function renderBanner() {
      var classNames = this.props.className ? "banner ".concat(this.props.className) : 'banner';
      var showBanner = this.props.showBanner !== undefined ? this.props.showBanner : true;

      if (showBanner) {
        if (this.props.title && (this.state.show === undefined || this.state.show)) {
          this.hideBanner();
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: "banner",
            className: classNames,
            style: this.props.css
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              flex: 1
            }
          }, this.renderImage(), this.renderTitle()));
        }

        if (this.props.children) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: "banner",
            className: classNames,
            style: this.props.css
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              flex: 1
            }
          }, this.props.children));
        }

        return null;
      }

      return null;
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      return /*#__PURE__*/_react["default"].createElement("div", null, this.props.title);
    }
  }, {
    key: "timeout",
    value: function timeout(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.visibleTime !== undefined && nextProps.visibleTime > 0) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          bannerMessage: nextProps.bannerMessage,
          visibleTime: nextProps.visibleTime
        });
      }

      if (nextProps.setShowBanner !== undefined) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          show: nextProps.showBanner
        });
      }

      return null;
    }
  }]);
  return Banner;
}(_react.Component);

Banner.propTypes = {
  title: _propTypes["default"].node,
  css: _propTypes["default"].object,
  visibleTime: _propTypes["default"].number,
  image: _propTypes["default"].string,
  imageClass: _propTypes["default"].string,
  transitionAppearTime: _propTypes["default"].number,
  transitionTime: _propTypes["default"].number,
  showBanner: _propTypes["default"].bool,
  setShowBanner: _propTypes["default"].func,
  children: _propTypes["default"].node
};
var _default = Banner;
exports["default"] = _default;